import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Dialog } from '@dojo/widgets/dialog';
import css from '../../css/expanded.m.css';
const icache = createICacheMiddleware();
const factory = create({
    icache,
    theme
})
    .properties()
    .children();
export const ExpandedBaseCard = factory(({ id, properties, children, middleware: { theme } }) => {
    const { aria = {}, expanded: open, widgetId = id, title, iconUrl, xqa, onRequestClose, underlay, extraClasses = [] } = properties();
    const themeCss = theme.classes(css);
    const [{ content }] = children();
    const closeable = true;
    return (open &&
        v('div', {
            id,
            widgetId,
            key: 'expandedCard',
            xqa,
            classes: [theme.variant(), themeCss.root]
        }, [
            w(Dialog, { open, aria, closeable, underlay, onRequestClose }, [
                {
                    content: v('div', { key: 'skel', classes: [themeCss.skel, ...extraClasses] }, [
                        title ? v('h2', { key: 'title', classes: [themeCss.title] }, [title]) : null,
                        iconUrl
                            ? v('div', { key: 'icon', classes: [themeCss.icon] }, [v('img', { src: iconUrl })])
                            : null,
                        v('div', { key: 'content', classes: [themeCss.expanded_content, xqa] }, [content])
                    ])
                }
            ])
        ]));
});
export default ExpandedBaseCard;
